import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme: Theme) => ({
  homePage: {
    backgroundColor: theme.palette.background.default,
  },
}));
